import { useSelector } from 'react-redux';
import { useCallback } from 'react';
export const useCan = () => {
  const permissionsSet = useSelector(state => state?.user?.permissionsSet || new Set());
  return useCallback((action, data = null) => {
    // console.log(`[Set] Ищем: "${action}". прав: ${permissionsSet.size}`);
    if (permissionsSet.has(action)) {
      return true;
    }
    return false;
  }, [permissionsSet]);
};